import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Plan from "./components/Plan";
import Inforisque from "./components/Inforisque";

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [{
            path: "/plan",
            element: <Plan />,
        }, {
            path: "/inforisque",
            element: <Inforisque />,
        }],

    },
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
